import React, { useContext } from 'react';
import AppContext from '../AppContext';
import styles from './Salesfive.module.scss';

const Salesfive = () => {
  const context = useContext(AppContext);
  const marketing = !!context.state.marketing;
  let style = {};

  if (marketing) {
    style = { zIndex: 999999999999 };
  }

  return (
  <div className={styles.wrapper} style={style}>
    <div className={styles.salesfive}>
      <div className={styles.builtBy}>built by</div>
      <div className={styles.logo} />
    </div>
  </div>
  );
};

export default Salesfive;
